import axios from "axios";
import CONFIG from "../config";
import { attachAuthInterceptor } from "./authInterceptor";

const customerApi = axios.create({
  baseURL: CONFIG.CUSTOMER_SERVICE_URL,
});

// Refresh goes to core-service, not the customer-lookup service. Using the
// shared interceptor gives this client the same silent 401-refresh-and-retry
// behavior as the other API clients, instead of logging the user out on the
// very first 401 (which it did before — a stale 1h access token meant an
// instant logout instead of a transparent refresh).
attachAuthInterceptor(customerApi, { refreshBaseUrl: CONFIG.EMPLOYEE_SERVICE_URL });

export const searchCustomers = async (params) => {
  const filtered = Object.fromEntries(
    Object.entries(params).filter(([_, v]) => v !== "" && v !== null)
  );
  const response = await customerApi.get("/search", {
    params: { type: "customers", ...filtered },
  });
  return response.data;
};

export const searchSales = async (params) => {
  const filtered = Object.fromEntries(
    Object.entries(params).filter(([_, v]) => v !== "" && v !== null)
  );
  const response = await customerApi.get("/search", {
    params: { type: "sales", ...filtered },
  });
  return response.data;
};
